import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import ShowHide from '@cotyorg/ccx-utils/js/components/ShowHide';

const generateShowHideClassNames = extraClassNames => classNames(
  'accordion__item-body',
  extraClassNames,
);

const generateItemContentClassNames = ({ contentExtraClassNames }) => classNames(
  'accordion__item-content',
  contentExtraClassNames,
);

const AccordionItemBody = ({
  children,
  id,
  index,
  isOpen,
  extraClass,
  contentExtraClassNames,
}) => (
  <ShowHide
    isOpen={isOpen}
    noTransitionClass="accordion__item-body--no-transition"
    extraClass={generateShowHideClassNames(extraClass)}
    extraProps={{
        id: `accordion-item-body-${id}-${index}`,
        role: 'tabpanel',
        'aria-labelledby': `accordion-item-title-${id}-${index}`,
      }}
  >
    <div className={generateItemContentClassNames({ contentExtraClassNames })}>
      {children}
    </div>
  </ShowHide>
);

AccordionItemBody.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  index: PropTypes.number,
  isOpen: PropTypes.bool,
  extraClass: PropTypes.string,
  contentExtraClassNames: PropTypes.string,
};

const mapStateToProps = (state, { id, index }) => ({
  isOpen: R.path(['accordions', id, index, 'isOpen'], state),
});

export default connect(mapStateToProps)(AccordionItemBody);
